import { defaultUILib } from '../defaults';
function invoke(uc, name, opt) {
  const owner = name in uc.ui ? uc.ui : defaultUILib;
  // @ts-ignore
  return owner[name](opt);
}
const getMessageBase = (uc, type) => function (opt, duration) {
  if (typeof opt === 'string') {
    opt = {
      content: opt,
      duration: duration || 3000,
      type
    };
  }
  return invoke(uc, 'message', opt);
};
/**
 * 这些方法会直接挂载到 UcBus 上面
 */
export const getBusUIMethods = uc => {
  const $message = getMessageBase(uc, 'info');
  $message.error = getMessageBase(uc, 'error');
  $message.warn = getMessageBase(uc, 'warning');
  $message.warning = getMessageBase(uc, 'warning');
  $message.info = getMessageBase(uc, 'success');
  $message.success = getMessageBase(uc, 'success');
  return {
    $alert(opt) {
      if (typeof opt === 'string') opt = {
        content: opt
      };
      return invoke(uc, 'alert', opt);
    },
    $confirm(opt) {
      if (typeof opt === 'string') opt = {
        content: opt
      };
      return invoke(uc, 'confirm', opt);
    },
    $message,
    $prompt(opt, defaultValue) {
      if (typeof opt === 'string') opt = {
        message: opt,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''
      };
      return invoke(uc, 'prompt', {
        message: '',
        defaultValue: '',
        password: false,
        ...opt
      }).then(x => x == null ? null : String(x)); // eslint-disable-line eqeqeq
    }
  };
};
//# sourceMappingURL=ui.js.map
